export class CycleError extends Error {
    ids;
    constructor(ids) {
        super(`Las dependencias forman un ciclo: ${ids.join(' → ')}`);
        this.ids = ids;
    }
}
export function criticalPath(tasks) {
    const byId = new Map(tasks.map((t) => [t.id, t]));
    const order = topoSort(tasks, byId);
    const es = new Map();
    const ef = new Map();
    for (const id of order) {
        const t = byId.get(id);
        const start = Math.max(0, ...t.dependsOn.filter((d) => byId.has(d)).map((d) => ef.get(d)));
        es.set(id, start);
        ef.set(id, start + Math.max(0, t.durationDays));
    }
    const total = Math.max(0, ...ef.values());
    const successors = new Map();
    for (const t of tasks)
        for (const d of t.dependsOn)
            if (byId.has(d))
                successors.set(d, [...(successors.get(d) ?? []), t.id]);
    const ls = new Map();
    const lf = new Map();
    for (const id of [...order].reverse()) {
        const succ = successors.get(id) ?? [];
        const finish = succ.length ? Math.min(...succ.map((s) => ls.get(s))) : total;
        lf.set(id, finish);
        ls.set(id, finish - Math.max(0, byId.get(id).durationDays));
    }
    const result = {};
    for (const id of order) {
        const slack = ls.get(id) - es.get(id);
        result[id] = { earlyStart: es.get(id), earlyFinish: ef.get(id), lateStart: ls.get(id), lateFinish: lf.get(id), slack, critical: slack === 0 };
    }
    // La ruta: tareas críticas en orden de inicio.
    const criticalPathIds = order.filter((id) => result[id].critical).sort((x, y) => result[x].earlyStart - result[y].earlyStart);
    return { durationDays: total, tasks: result, criticalPath: criticalPathIds };
}
function topoSort(tasks, byId) {
    const state = new Map();
    const out = [];
    const visit = (id, stack) => {
        const s = state.get(id);
        if (s === 'done')
            return;
        if (s === 'visiting')
            throw new CycleError([...stack.slice(stack.indexOf(id)), id]);
        state.set(id, 'visiting');
        for (const d of byId.get(id).dependsOn)
            if (byId.has(d))
                visit(d, [...stack, id]);
        state.set(id, 'done');
        out.push(id);
    };
    for (const t of tasks)
        visit(t.id, []);
    return out;
}
/** ¿Agregar la dependencia `from → to` crearía un ciclo? (para validar antes de guardar). */
export function wouldCreateCycle(tasks, taskId, dependsOnId) {
    if (taskId === dependsOnId)
        return true;
    const deps = new Map(tasks.map((t) => [t.id, t.dependsOn]));
    const seen = new Set();
    const stack = [dependsOnId];
    while (stack.length) {
        const id = stack.pop();
        if (id === taskId)
            return true;
        if (seen.has(id))
            continue;
        seen.add(id);
        stack.push(...(deps.get(id) ?? []));
    }
    return false;
}
//# sourceMappingURL=critical-path.js.map